import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../components/Button";
import Input from "../../components/Input";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { forgotPasswordSchema } from "./schemas/authenticationSchema";

import { sendResetPwEmail } from "./api/authRequest";

const ForgotPassword = () => {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(forgotPasswordSchema),
    });

    const onSubmit = async (data) => {
        setError("");

        try {
            await sendResetPwEmail(data);
            setSuccess(true);
        } catch (err) {
            console.error("Error sending password reset email:", err);
            if (err.response?.status === 404) {
                setError(
                    "No account with the provided email. Please check your email and try again."
                );
            } else {
                setError(
                    "An error occurred while sending the password reset email. Please try again later."
                );
            }
        }
    };

    return (
        <>
            <div className="custom-container mx-auto w-4/5 lg:w-1/2">
                <div className="text-base md:text-2xl text-center mx-auto mb-2">
                    <h4 className="mb-2">Forgot Password</h4>
                    <p>Please enter the email used when registering.</p>
                </div>
                <form
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Input
                        label="Email"
                        name="email"
                        register={register}
                        errors={errors}
                        placeholder="Enter your email"
                    />
                    {error && <p className="text-red-600">{error}</p>}
                    {success && !error && (
                        <p className="text-teal-600 font-semibold">
                            Reset password email sent! Check your inbox.
                        </p>
                    )}
                    <Button type="submit" isLoading={isSubmitting}>
                        Send Reset Password Link
                    </Button>
                </form>
                <Button
                    className="mt-4"
                    onClick={() => navigate("/")}
                    variant="outline"
                >
                    &lt; Back
                </Button>
            </div>
        </>
    );
};

export default ForgotPassword;
